import { render, staticRenderFns } from "./IssuesEdit.vue?vue&type=template&id=3e36cbcb&"
import script from "./IssuesEdit.vue?vue&type=script&lang=js&"
export * from "./IssuesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports